import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { vacationStatuses } from './utils/VacationStatus';
import { reportEvent } from './helper';
import ProfileBanner from './ProfileBanner/ProfileBanner';
import VacationPopup from './VacationPopup';
import CancelVacationModal from './CancelVacationModal';

class OutOfOffice extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isVacationPopoverOpen: false,
            isCancelVacationPopoverOpen: false,
            startDate: props.start_date ? props.start_date * 1000 : null,
            endDate: props.end_date ? props.end_date * 1000 : null,
            buyerMessage: props.message_for_buyer,
            allowContact: props.allow_contact,
            isOnVacation: props.is_on_vacation,
            isPageOwner: props.is_page_owner,
            vacationStatus: props.vacation_status
        };

        this.popupRef = createRef();

        this.openPopup = this.openPopup.bind(this);
        this.submitAllVacationDetails = this.submitAllVacationDetails.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    componentDidMount() {
        document.addEventListener('open_popup', this.openPopupHandler);
        document.addEventListener('open_out_of_office_set_to_available_modal', this.openCancelVacationPopup);
    }

    componentWillUnmount() {
        document.removeEventListener('open_popup', this.openPopupHandler);
        document.removeEventListener('open_out_of_office_set_to_available_modal', this.openCancelVacationPopup);
    }

    openPopupHandler = (event) => {
        if (event.detail) {
            this.openPopup(event);
            return;
        }

        this.setState({ isOnVacation: event.detail });

        reportEvent('click_off', {
            'current_page_type': 'seller_page',
            'seller': {
                'id': this.props.user_id
            }
        });
    };

    submitAllVacationDetails(data) {
        this.setState({
            startDate: data.startDate,
            endDate: data.endDate,
            buyerMessage: data.buyerMessage,
            allowContact: data.allowContact,
            isOnVacation: true,
            isPageOwner: true,
            vacationStatus: data.vacationStatus
        });
    }

    openPopup(e, type = null) {
        e && e.preventDefault();
        type ? reportEvent('click_edit', { current_page_type: type }) : reportEvent('click_on');
        this.setState({ isVacationPopoverOpen: true });
    }

    closePopup(e, data, fromSubmit = false) {
        // closed without submit
        if (!fromSubmit) {

            // in case of ooo off close the toggle.
            if (!this.state.isOnVacation) {
                const event = new CustomEvent('popup_close', { detail: false });
                document.dispatchEvent(event);
            }
        } else if (e && e.preventDefault) {
            e.preventDefault();
        }

        data && this.submitAllVacationDetails(data);

        this.setState({ isVacationPopoverOpen: false });
    }

    closeCancelVacationModal = (submitted = false) => {
        this.setState({ isCancelVacationPopoverOpen: false });

        if (submitted) {
            setTimeout(() => {
                location.reload();
            }, 3000);
        }
    };

    openCancelVacationPopup = () => {
        this.setState({
            isCancelVacationPopoverOpen: true,
            isVacationPopoverOpen: false
        });
    };

    render() {
        const {
            user_id,
            username,
            displayName
        } = this.props;

        const {
            isCancelVacationPopoverOpen,
            isVacationPopoverOpen,
            isPageOwner,
            isOnVacation,
            vacationStatus
        } = this.state;

        let showBanner = true;

        if (!isPageOwner && !isOnVacation) {
            showBanner = false;
        }

        if (isPageOwner && vacationStatus && (vacationStatus !== vacationStatuses.pending && vacationStatus !== vacationStatuses.active)) {
            showBanner = false;
        }

        return (
            <div className="out-of-office">
                {showBanner && <ProfileBanner {...this.state}
                    openCancelVacationPopup={this.openCancelVacationPopup}
                    userId={user_id}
                    username={username}
                    displayName={displayName}
                    openPopup={this.openPopup}/>}

                {isVacationPopoverOpen && <VacationPopup {...this.state}
                    userId={user_id}
                    username={username}
                    openCancelVacationPopup={this.openCancelVacationPopup}
                    closePopup={this.closePopup}/>}

                {isCancelVacationPopoverOpen && (
                    <CancelVacationModal username={username} close={this.closeCancelVacationModal}
                        vacationStatus={vacationStatus}/>
                )}
            </div>
        );
    }
}

OutOfOffice.propTypes = {
    type: PropTypes.string.isRequired,
    is_page_owner: PropTypes.bool,
    user_id: PropTypes.number.isRequired,
    start_date: PropTypes.number,
    end_date: PropTypes.number,
    allow_contact: PropTypes.bool,
    message_for_buyer: PropTypes.string,
    is_on_vacation: PropTypes.bool,
    username: PropTypes.string,
    displayName: PropTypes.string,
    vacation_status: PropTypes.string
};

OutOfOffice.defaultProps = {
    type: 'profile',
    user_id: 0,
    is_on_vacation: false,
    is_page_owner: false,
    allow_contact: false,
    vacation_status: vacationStatuses.historic
};

export default OutOfOffice;
